module.exports = __webpack_public_path__ + "static/media/eqli.7ed87cfe.svg";